export default "__VITE_PUBLIC_ASSET__04b11776__"